/*
 * @Date: 2024-06-27 11:39:21
 * @Author: haodong chenghd@dreamdt.cn
 * @LastEditors: haodong chenghd@dreamdt.cn
 * @LastEditTime: 2024-07-08 17:28:32
 */
import * as superSearch from "./superSearch/index.js";
// import vuxLoader from "../../common/vxeLoader.js";

export const {
  DsfSuperSearch,
  DsfSuperSearchFilter,
  DsfSuperSearchItem,
  DsfSuperSearchInput,
  DsfSuperSearchNumber,
  DsfSuperSearchSelect,
  DsfSuperSearchTreeSelect,
  DsfSuperSearchDataPicker,
  DsfSuperSearchPeriod,
  DsfSuperSearchDataChoice
} = superSearch;

export DsfDataGridSelection from "./datagridSelection.js";

export const DsfElTable = Vue.defineLazyComponent(() => require("./table/table"));

export const DsfDataGridColumn = dsf.defineLazyComponent("DsfDataGridColumn", () =>
  require("./datagridColumn.js")
);
export const DsfDataGridCellContent = dsf.defineLazyComponent("DsfDataGridCellContent", () =>
  require("./datagridCellContent.vue")
);

//列表组件中的表格子组件
export const DsfDataGridTable = Vue.defineAsyncComponent(() =>
  import(/* webpackChunkName: "platform_pc_datagrid" */ "./datagridTable")
);
//列表组件中卡片子组件
export const DsfDataGridCard = Vue.defineAsyncComponent(() =>
  import(/* webpackChunkName: "platform_pc_datagrid" */ "./datagridCard")
);

//自定义列过滤
export const DsfDataGridColumnsFilter = Vue.defineAsyncComponent(() =>
  import(/* webpackChunkName: "platform_pc_datagrid" */ "./columnFilter.vue")
);

//自定义列数据过滤
export const DsfColumnDataFileter = Vue.defineAsyncComponent(() =>
  import(/* webpackChunkName: "platform_pc_datagrid" */ "./columnDataFilter.vue")
);

//自定义排序
export const DsfCustomOrder = Vue.defineAsyncComponent(() =>
  import(/* webpackChunkName: "platform_pc_datagrid" */ "./customOrder.vue")
);

//列表多选对话框
export const DsfPlatformMultipleSelectionTable = Vue.defineAsyncComponent(() =>
  import(/* webpackChunkName: "platform_pc_datagrid" */ "./multipleSelectionDialog.vue")
);

//检索模板管理
export const DsfDataGridTemplateManage = Vue.defineAsyncComponent(() =>
  import(/* webpackChunkName: "platform_pc_datagrid" */ "./superSearch/templateManage.vue")
);

//检索模板
export const DsfDataGridTemplateSave = Vue.defineAsyncComponent(() =>
  import(/* webpackChunkName: "platform_pc_datagrid" */ "./superSearch/templateSave.vue")
);

//静态列表
export const DsfStaticList = dsf.defineAsyncComponent("DsfStaticList", () =>
  import(/* webpackChunkName: "platform_pc_prototype" */ "./staticList.vue")
);
//列表组件
export const DsfDataGrid = dsf.defineAsyncComponent("DsfDataGrid", () => {
  const arr = Object.values(superSearch);
  //注入datagrid依赖项（高级检索，列表，卡片）
  return dsf.requestAsyncComponents([...arr, DsfDataGridTable, DsfDataGridCard]).then((res) => {
    return import(/* webpackChunkName: "platform_pc_datagrid" */ "./datagrid.vue");
  });
});
//列表状态显示组件
export const DsfListStatus = dsf.defineAsyncComponent("DsfListStatus", () =>
  import(/* webpackChunkName: "platform_pc_datagrid" */ "./listStatus.vue")
);

//自定义列表组件
export const DsfCustomList = dsf.defineAsyncComponent("DsfCustomList", () =>
  import(/* webpackChunkName: "platform_pc_datagrid" */ "./customList.vue")
);

//树列表组件
export const DsfTreeDataGrid = dsf.defineAsyncComponent("DsfTreeDataGrid", () => {
  return dsf.vxeTable
    .load()
    .then(() => {
      return dsf.requestAsyncComponents([DsfDataGrid, DsfTreeDataGridTable]);
    })
    .then((res) => {
      return import(/* webpackChunkName: "platform_pc_tree_datagrid" */ "./treeDataGrid.vue");
    });
});

//树列表组件子组件
export const DsfTreeDataGridTable = Vue.defineAsyncComponent(() => {
  return dsf.vxeTable.load().then(() => {
    return import(/* webpackChunkName: "platform_pc_tree_datagrid" */ "./treeDataGridTable.vue");
  });
});

export const DsfTreeDataGridColumn = Vue.defineAsyncComponent(() => {
  return dsf.vxeTable.load().then(() => {
    return import(/* webpackChunkName: "platform_pc_tree_datagrid" */ "./treeDatagridColumn");
  });
});
